import {
  S3Client,
  PutObjectCommand,
} from "@aws-sdk/client-s3";

// Initialize the S3 client
const s3Client = new S3Client({
  region: process.env.REACT_APP_AWS_REGION,
  credentials: {
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  },
});

export async function uploadToS3(file: Uint8Array, fileName: string): Promise<string> {
  const params = {
    Bucket: process.env.REACT_APP_AWS_BUCKET_NAME_UPLOAD,
    Key: fileName,
    Body: file,
  };

  try {
    await s3Client.send(new PutObjectCommand(params));
    return `https://${process.env.REACT_APP_AWS_BUCKET_NAME_UPLOAD}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${fileName}`;
  } catch (error) {
    console.error("Error uploading to S3:", error);
    throw error;
  }
}